// extracted by mini-css-extract-plugin
export var legendIndicator = "_dz-1";
export var legendRight = "_dz-0";